import React, { useState } from "react";
import { Table } from "../../../../components/ui/Table";
import { Tooltip } from "../../../../components/ui/Tooltip";
import { Alert, Button, Stack } from "react-bootstrap";
import * as AiIcons from "react-icons/ai";
import _ModalDevicesRcsAgent from "../../../../components/modal/administration/customer/_ModalDevicesRCSAgent";
import _ModalAddDeviceTestRCSAgent from "../../../../components/modal/administration/customer/_ModalAddDeviceTestRCSAgent";
import { useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { httpClient } from "../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../utils/ApiEndpoint";
import { useAuth } from "../../../../Context/AuthContext";
import _ModalDanger from "../../../../components/modal/_ModalDanger";
import { classNames } from "../../../../utils/helpers";
const CustomerAgentDevices = () => {
  const { partnerId, vcPartner } = useParams();

  const auth = useAuth();
  let { token } = auth.getSessionData();

  const [visible, setVisible] = useState({
    data: null,
    visible: false,
  });
  const [addDevice, setAddDevice] = useState({
    data: null,
    visible: false,
  });

  const [remove, setRemove] = useState({
    visible: false,
    data: null,
  });

  const {
    data: testers,
    refetch,
    isPending: isLoadingDevices,
  } = useQuery({
    queryKey: ["customer-agent-devices", partnerId],
    queryFn: async () => {
      const response = await httpClient(
        "post",
        `${ApiEndpoint}rcs/listdevices`,
        {
          agentId: vcPartner,
        },
        token,
      );

      const res = response?.data?.data?.testers;

      return res;
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  const { mutate: deleteDevice, isPending: isLoading } = useMutation({
    mutationKey: ["delete-device-rcs-agent"],
    mutationFn: async () => {
      const phone = remove.data.phoneNumber.replace("+52", "");

      const response = await httpClient(
        "post",
        `${ApiEndpoint}rcs/removetester`,
        {
          agentId: vcPartner,
          phone: phone,
        },
        token,
      );

      return response.data;
    },
    onSuccess: () => {
      refetch();
      setRemove({
        visible: false,
        data: null,
      });
    },
  });

  const columns = [
    {
      accessor: "phoneNumber",
      Header: "Número",
      Cell: (rowData) => {
        const item = rowData.row.original.phoneNumber;
        return (
          <span>
            {item
              .replace("+52", "")
              .replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")}
          </span>
        );
      },
    },
    {
      accessor: "name",
      Header: "Nombre",
    },
    {
      accessor: "inviteStatus",
      Header: "Estado",
      Cell: (rowData) => {
        const item = rowData.row.original.inviteStatus;

        const inviteStatusMap = {
          ACCEPTED: {
            text: "Aceptado",
            className: "bg-green-100 text-green-700",
          },
          PENDING: {
            text: "Pendiente",
            className: "bg-yellow-100 text-yellow-700",
          },
          DECLINED: { text: "Declinado", className: "bg-red-100 text-red-700" },
        };

        return (
          <div
            className={classNames(
              `flex gap-2 items-center px-2 py-1 w-[120px] justify-center rounded-lg text-xs font-medium`,
              inviteStatusMap[item]?.className,
            )}
          >
            <span className="font-semibold">{inviteStatusMap[item]?.text}</span>
          </div>
        );
      },
    },
    {
      accessor: "actions",
      Header: "Acciones",
      disableSortBy: true,
      headerProps: {
        className: "text-center w-[180px]",
      },
      cellProps: {
        className: "text-center",
      },
      Cell: (rowData) => {
        let item = rowData.row.original;

        return (
          <div className="flex justify-end gap-2">
            {item.inviteStatus === "ACCEPTED" && (
              <Tooltip message="Enviar mensaje de prueba" placement="top">
                <button
                  className="bg-gray-100 hover:bg-gray-200 hover:text-gray-400 text-gray-700 border-none rounded-lg flex items-center gap-2 px-2 py-1"
                  onClick={() =>
                    setVisible({
                      data: item,
                      visible: true,
                    })
                  }
                >
                  <span className="material-symbols-outlined">
                    business_messages
                  </span>
                </button>
              </Tooltip>
            )}
            <Tooltip message="Eliminar dispositivo" placement="top">
              <button
                className="bg-gray-100 hover:bg-gray-200 hover:text-gray-400 text-gray-700 border-none rounded-lg flex items-center gap-2 px-2 py-1"
                onClick={() =>
                  setRemove({
                    data: item,
                    visible: true,
                  })
                }
              >
                <span className="material-symbols-outlined">delete</span>
              </button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <Stack direction="horizontal" gap={2} className="AlignItemsTop">
        <div>
          <h2>Dispositivos Test: {vcPartner} </h2>
          <h3>Administre la lista de dispositivos test de los agentes RCS.</h3>
        </div>
        <div className="ms-auto">
          <Button
            variant="outline-primary"
            size="sm"
            onClick={() => {
              setAddDevice({
                data: null,
                visible: true,
              });
            }}
          >
            <AiIcons.AiOutlinePlus /> Agregar
          </Button>{" "}
        </div>
      </Stack>
      <Stack>
        <Alert variant="info" className="mt-3">
          <div className="flex justify-start gap-2">
            <span className="material-symbols-outlined">info</span>
            <p>
              Los agentes pueden enviar un máximo de 20 invitaciones a
              verificaciones por día, con un límite total de 200 invitaciones.
            </p>
          </div>
        </Alert>
      </Stack>
      <div className="bg-white rounded-lg px-4 py-2">
        <Table
          data={testers}
          columns={columns}
          loading={isLoadingDevices}
          config={{
            search: true,
            pagination: true,
            pageSize: 10,
            perPage: 10,
            footer: true,
          }}
        />
      </div>
      <_ModalDevicesRcsAgent
        visible={visible.visible}
        data={{
          ...visible.data,
          partnerId,
        }}
        onClose={() =>
          setVisible({
            data: null,
            visible: false,
          })
        }
        title="Enviar mensaje de prueba"
      />
      <_ModalAddDeviceTestRCSAgent
        visible={addDevice.visible}
        data={{
          ...addDevice.data,
          vcPartner,
        }}
        onClose={() =>
          setAddDevice({
            data: null,
            visible: false,
          })
        }
        refetch={refetch}
        title="Enviar invitación"
      />
      <_ModalDanger
        title={`Eliminar dispositivo ${remove?.data?.phoneNumber}`}
        description={`¿Está seguro de que desea eliminar este dispositivo?`}
        visible={remove.visible}
        onClose={() => setRemove({ visible: false, data: null })}
        onAction={deleteDevice}
        isLoading={isLoading}
      />
    </div>
  );
};

export default CustomerAgentDevices;
